export default __webpack_public_path__ + "static/media/silber.66db9077.png";